import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import styled from "styled-components";
import { colors } from "../../res/values/values";
import {
  CalendarToday
} from "@material-ui/icons";
import DatePicker, { registerLocale } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import en from "date-fns/locale/en-GB";
import { format, addDays, subDays, addWeeks, subWeeks } from "date-fns";
import { useState, forwardRef } from "react";
registerLocale("en", en);

//#region STYLES

const Container = styled.div`
  min-height: 10rem;
  padding: 10px;
  border-width: 1px;
  border-style: solid;
  border-color: lightgray;
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
`;
const Button = styled.div`
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 1px;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  background-color: ${colors.primaryColor};
  border-color: #dddddd #dddddd #b3b3b3 #b7b7b7;
  color:${colors.blackColor};
  border-radius: 2px;
  margin: 2px;
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.blackColor};
    color: ${colors.primaryColor};
  }
`;
const ButtonDatePricker = styled.div`
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  background-color: ${colors.primaryColor};
  border-color: #b3b3b3 #b3b3b3 #b3b3b3 #b3b3b3;
  color:${colors.blackColor};
  border-radius: 2px;
  margin: 2px;
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.blackColor};
    color: ${colors.primaryColor};
  }
`;
const Title = styled.span`
  font-size: 1rem;
  color: ${colors.blackColor};
  font-weight: 500;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 10px;
  flex: 3;
`;
//#endregion

export default function DeliveryMethodComponents(props) {

  const handleChange = async (event) => {
    await props.changeDeliveryMethod(event.target.value);
    //props.setDeliveryMethod(event.target.value);
  };

  return (
    <Container>
      <FormControl>
        <Title>
          Please select the preferred shipping method to use on this order.
        </Title>
        <RadioGroup
          aria-labelledby="radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={props.deliveryMethod}
          onChange={handleChange}
        >
          <FormControlLabel
            value="Delivery"
            control={
              <Radio
                sx={{
                  color: colors.blackColor,
                  "&.Mui-checked": {
                    color: colors.blackColor,
                  },
                }}
              />
            }
            label="Delivery"
          />
          <FormControlLabel
            value="Collection"
            control={
              <Radio
                sx={{
                  color: colors.blackColor,
                  "&.Mui-checked": {
                    color: colors.blackColor,
                  },
                }}
              />
            }
            label="Collection"
          />
        </RadioGroup>
      </FormControl>

      <ButtonContainer>
        <ButtonDatePricker onClick={_=>props.setVisibleDatePicker(true)}> 
          Requested Datetime : { props.deliveryMethod==='Collection' ? format(props.requestedDate, "dd/MM/yyyy HH:mm") : format(props.requestedDate, "dd/MM/yyyy")}
        </ButtonDatePricker>
        <Button
          onClick={() => {
            props.changeOpenStatus(true);
          }}
        >
          Continue
        </Button>
      </ButtonContainer>
    </Container>
  );
}
